<template>
  <div class="bg">
    <div class="wrapper">
      <worker-filter style="z-index: 100" v-on:gradeSelect="getAllStudents"></worker-filter> 
      <!-- v-on:gradeSelect="getAllStudents" -->
      <div class="stu-list">
        <div class="title-wrapper">
          <v-title page-title="签到记录"></v-title>
        </div>
        <div class="list">
            <!-- <h3 class="course_title" v-text="list.course_title"></h3> -->
              <div v-if="studentList.length > 0" class="selectList">
                <select v-model="selectedCourse" class="selectStyle">
                  <option v-for="item in studentList" :value="item.course_title" :key="item.course_title">
                    {{ item.course_title }}
                  </option>
                </select>
                <ul>
                  <li v-for="(student,index) in filteredStudents" :key="student.userId">
                    <card-view>
                      <check-in-item slot="content"
                                    :student="student"
                                    :userImage="student.userImage.length"
                                    :reasons="reasons"
                                    :position="index"
                                    @itemChecked="itemChecked"
                                    >
                      </check-in-item>
                    </card-view>
                  </li>
                </ul>
              </div>
              <div v-else class="no-students">
                暂无签到内容
              </div>
        </div>
        

        <div class="btn-wrapper">
          <div class="back" v-tap="{methods:back}">
            返回
          </div>

          <div class="submit" v-tap="{methods:submit}">
            提交
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WorkerFilter from '../components/WorkerFilter.vue';
  import VTitle from '../components/VTitle.vue';
  import CheckInItem from '../components/CheckInItem.vue';
  import CardView from '../components/CardView.vue';
  import Teacher from '../api/teacher';
  import { Toast, Indicator } from 'mint-ui';
  import { mapGetters,mapState } from 'vuex';
  import {list,studentImageList} from '../utils/studentImageLsit'
  export default{
    name: 'student-check-in',
    created() {
      // this.getAllStudents();
      this.getAllSignInStatus();
    },
    data() {
      return {
        reasons: [],//缺勤状态数据
        student:[],
        //courseData: [], // 存储从后端获取的数据
        selectedCourse: this.$store.state.teacherschools.selectedCourse, // 存储选定的课程标题
        selectedStudents: [], // 存储选定课程下的学生数据
        lessons:'',
        // listStudent:{}
      };
    },
    components: {
      WorkerFilter,
      VTitle,
      CheckInItem,
      CardView,
    },
    mounted(){
      //挂载完成后，再次操作计算属性，并重新给计算出的数据进行加工
      this.handleComputedValue()
    },
    methods: {
      //加工计算出的数组对象
      handleComputedValue(){
        //如果studentImageLsit.js存储的list数组长度不等于0，进行给数组userImage添加图片
        if(this.filteredStudents.length!=0){
          if(list.length!=0){
            list.forEach(item =>{
              this.filteredStudents[item.id].userImage = item.imgList;
            })
          }
        }
      },
      //获取签到出勤数据
      getAllSignInStatus(){
          Teacher.getAllQueryTheSignInStatus().then(response =>{
              this.reasons=response.data
          })
          
      },
      back(params) {
        //返回主页清空上传的图片和选中的出勤状态
        if(this.filteredStudents.length!=0){
          if(list.length!=0){
            list.forEach(item =>{
              this.filteredStudents[item.id].userImage = [];
              this.filteredStudents[item.id].normal = '';
            })
          }
        }
        //清空上传的图片
        studentImageList('');
        this.$router.goBack();
      },
      getAllStudents() {
        // Indicator.open({text: '获取签到信息...', spinnerType: 'fading-circle'});
        this.$store.dispatch('getAllSigninStudentList',{campusId:this.school.id,classId:this.grade.id,lessons:this.lessons});
      //   Teacher.getAllSignInStudents(this.school.id, this.grade.id,this.lessons).then(response => {
      //     this.courseData = response.rows;
      //     // 将第一项数据的值赋给 selectedCourse 属性
      //     if (this.courseData.length > 0) {
      //       this.selectedCourse = this.selectedCourseStore!='' ? this.selectedCourseStore : this.courseData[0].course_title;
      //     }
      //     Indicator.close();
      //   }).catch(e => {
      //     Indicator.close();
      //   });
      },
      //子组件传递大按钮单击是否选中 选中，正常出勤，未选中缺勤
      itemChecked(normal,index) {  
        //给每个学生赋值出勤状态
        this.filteredStudents[index].normal=normal;
      }, 
      submit() {
      // 没有签到学生
        if (this.filteredStudents.length <= 0) {
          Toast({message: '没有签到学生', position: 'middle', duration: 3000});
          return;
        }else{
          //拿到初始渲染的数组，
          for (let index = 0; index < this.filteredStudents.length; index++) { 
              //循环出每条没有课时的学生
              if (this.filteredStudents[index].isArrears) {
                continue;
              }
              //存储有课时的学生
              const student = this.filteredStudents[index]
              if (student.normal==='') {
                Toast({message: `没有填写${student.userName}缺勤的原因`, position: 'middle', duration: 3000});
                  return false;
              }
              // else if(student.normal=='0'&&student.userImage.length===0){
              //   Toast({message: `没有上传${student.userName}学生照片`, position: 'middle', duration: 3000});
              //     return false;
              // }
           }
            Indicator.open({text: '正在签到...', spinnerType: 'fading-circle',duration:2000});
            Teacher.createSignIn(this.filteredStudents).then(response => {
              if (response.msg === '操作成功') {
                studentImageList('')
                this.$store.commit('selectedCourse','')
                Toast({message: '签到成功', position: 'bottom', duration: 3000});
                this.getAllStudents();
              } else {
                Toast({message: response.message, position: 'middle', duration: 3000});
              }
              Indicator.close();
            }).catch(e => {
              Indicator.close();
            });
          }
        },
    },
    computed: {
      ...mapGetters({
        school: 'school',
        grade: 'grade',
        imgList:'imgList',
        selectedCourseStore:'selectedCourse'
        
      }),
      ...mapState({
        studentList:state=>state.teacherschools.studentList
      }),
      filteredStudents() {
        //计算学生信息，按course_title分类返回对应的学生
        if (this.selectedCourseStore) {
          const course = this.studentList.find(item => item.course_title === this.selectedCourseStore);
          return course ? course.students : [];
        } else {
          return [];
        }
      }
    },
    watch:{
      //监听下拉框选择的分类，不同分类清空选中状态
      'selectedCourse':{
        handler(newValue,oldValue){
          if(newValue){
            //存储选中的时什么分类
            this.$store.commit('selectedCourse',newValue)
          }
        }
      },
      'filteredStudents':{
        handler(newVal,oldVal){
            newVal.forEach(value =>{
              if(value.isArrears==true){
                const properties = {
                  normal:5,
                  schoolId:this.school.id,
                  classId:this.grade.id,
                  userImage:[]
                }
                Object.assign(value,properties);
              }else{
                const properties = {
                  normal:'',
                  schoolId:this.school.id,
                  classId:this.grade.id,
                  userImage:[]
                }
                //合并数据
                Object.assign(value,properties);
              }
            })
        }
      },
      "studentList":{
        handler(newVal,oldVal){
          if(newVal.length > 0){
            //首次加载默认选中下拉框分类的第一项值
            this.selectedCourse =  newVal[0].course_title;
            //进行存储选中的分类
            this.$store.commit('selectedCourse',newVal[0].course_title)
          }else{
            this.selectedCourse = ''
            this.$store.commit('selectedCourse','')
          }
        }
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .bg {
    @include bg-img('../assets/img/common/Bg');
    width: 100%;
    .wrapper {
      position: relative;
      width: 100%;
      padding-top: px2rem(48);
      .stu-list {
        position: relative;
        margin: px2rem(150) auto 0 auto;
        background-size: 100% 100%;
        height: px2rem(1067);
        width: px2rem(700);
        @include bg-img('../assets/img/teacher/checkin_bg');
        .title-wrapper {
          position: absolute;
          left: px2rem(143);
          top: px2rem(-50);
        }
        .course_title {
          margin-left: px2rem(10);
          margin-top: px2rem(25);
          position: relative;
          // top: px2rem(66);
          font-weight: bolder;
          color: #a56715;
          font-size: px2rem(35);
        }
        
        .list {
          position: absolute;
          left: px2rem(75);
          right: px2rem(75);
          top: px2rem(80);
          height: px2rem(820);
          overflow-y: auto;
          overflow-x: hidden;
          -webkit-overflow-scrolling: touch;
          .outer-wrapper {
            width: auto;
          }
          .selectList{
            margin-bottom: px2rem(20);
            .selectStyle{
              // border: none;
              border-radius: px2rem(20);
              margin-left: px2rem(5);
              width: px2rem(280);
              height: px2rem(60);
              line-height: px2rem(50);
              margin-bottom: px2rem(30);
            }
          }
          .no-students {
            margin: px2rem(20) 0;
            font-size: px2rem(30);
            width: 100%;
            text-align: center;
          }
        }

        .btn-wrapper {
          width: 100%;
          height: px2rem(78);
          position: absolute;
          bottom: px2rem(64);
          font-size: px2rem(36);

          div {
            font-family: 'SXSLST';
            text-align: center;
            color: white;
            @include text-shadow(2, 2, rgba(21, 117, 6, 0.4))
          }

          .back {
            position: relative;
            display: inline-block;
            left: px2rem(76);
            @include bg-img('../assets/img/teacher/highlight');
            height: px2rem(78);
            line-height: px2rem(78);
            width: px2rem(220);
          }

          .submit {
            display: inline-block;
            position: relative;
            left: px2rem(150);
            line-height: px2rem(78);
            @include bg-img('../assets/img/teacher/highlight');
            height: px2rem(78);
            width: px2rem(220);
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// StudentCheckIn.vue?7b3916d1